import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IPhoneField {
	changePhoneNumber: (value: string) => void;
}

const PhoneField: React.FC<IPhoneField> = ({ changePhoneNumber }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterPhoneNumber') },
			() => ({
				validator(_, value) {
					if (!value || value.match(/^\+(\d{10,12})$/gm)) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('phoneShouldContainDigits', { value: '10 - 12' })));
				},
			}),
		],
		[t],
	);

	return (
		<FormInput
			testId="PhoneField"
			name="phoneNumber"
			label="phoneNumberLabel"
			onChange={changePhoneNumber}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(PhoneField);
